'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var metaballs = exports.metaballs = function metaballs(defs) {
    var filters = defs.append('filter');

    filters.attr('id', 'metaballs');

    filters.append('feGaussianBlur').attr('in', 'SourceGraphic').attr('stdDeviation', 10).attr('result', 'blur');

    filters.append('feColorMatrix').attr('in', 'blur').attr('mode', 'matrix').attr('values', '1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 50 -10').attr('result', 'contrast');

    filters.append('feBlend').attr('in', 'SourceGraphic').attr('in2', 'contrast');

    return filters;
};
//# sourceMappingURL=metaballs.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ansyn-event-drops/dist-es5/metaballs.js
// module id = ../../../../ansyn-event-drops/dist-es5/metaballs.js
// module chunks = vendor